module.exports = __webpack_public_path__ + "img/glenn.bf759f8a.webp";